require("!!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/raw-loader/index.js!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/tinymce/plugins/link/plugin.js"))


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/script-loader!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/tinymce/plugins/link/plugin.js
// module id = ../../../../script-loader/index.js!../../../../tinymce/plugins/link/plugin.js
// module chunks = 4